<app-modal></app-modal>
<app-modal-error></app-modal-error>
<app-flow-states-tooltip></app-flow-states-tooltip>

<div class="wrapper">
  <app-page-loader></app-page-loader>

  <app-navbar></app-navbar>

  <div class="front-page-body">
    <router-outlet>
    </router-outlet>
  </div>

  <app-footer></app-footer>

  <!-- <app-cookies-approve-alert></app-cookies-approve-alert> -->
</div>
